import { createSelector } from '@reduxjs/toolkit';

const selectLogsState = (state: any) => state.log;

export const selectLogsSelector = createSelector(
    [selectLogsState],
    (logState) => ({
        page: Number(logState?.logListParams?.page || 1),
        per_page: Number(logState?.logListParams?.per_page || 25),
        total: Number(logState?.logListParams?.total || 0),
        data: logState?.data || []
    })
);

export const selectLogLoading = createSelector(
    [selectLogsState],
    (logState) => logState.loading
); 